module.exports = __webpack_public_path__ + "img/SenateLiveLogo_Color_Hor-01_smtxt3.91d75200.png";